import { getUserToken } from '../../api';

export const COMPANY_SET_CONFIG = 'company/set/config';
export const COMPANY_SET_CONFIG_USERNAME = 'company/set/config/username';
export const COMPANY_SET_CONFIG_USERID = 'company/set/config/userid';

export const setConfig = config => ({
  type: COMPANY_SET_CONFIG,
  payload: { config },
});

export const setConfigUsername = username => ({
  type: COMPANY_SET_CONFIG_USERNAME,
  payload: { username },
});

export const setConfigUserid = userid => ({
  type: COMPANY_SET_CONFIG_USERID,
  payload: { userid },
});

export const fetchToken = () => async dispatch => {
  const res = await getUserToken();
  if (res !== null) {
    dispatch(setConfigUsername(res.preferred_username));
    dispatch(setConfigUserid(res.user_id));
  }
};
